import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=3f8c7e9b&"
import script from "./BaseTable.vue?vue&type=script&lang=js&"
export * from "./BaseTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=3f8c7e9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports